module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-app",
    class: [cTheme]
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb53c26c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/src/app.vue
// module id = 168
// module chunks = 0